import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch,useAppSelector } from 'store'

import {
  getUserToken,
  refreshAuthToken,
  selectAuthStatus,
  selectUserPermissions
} from 'services/authSlice'
import { LoadingStatus } from 'types/user'
import { minutesToMilliseconds } from 'utils/date'
import { PATHS } from 'utils/paths'
import { isNilOrEmpty, isNotNilOrEmpty } from 'utils/ramda'

export const RefreshToken = () => {
  const dispatch = useAppDispatch()
  const userToken = useAppSelector(getUserToken)
  const authStatus = useAppSelector(selectAuthStatus)
  const userPermissions = useAppSelector(selectUserPermissions)
  const { pathname } = useLocation()

  const startRefreshToken = ![
    PATHS.home,
    PATHS.login,
    PATHS.setPassword,
    PATHS.resetPassword,
    PATHS.landingPagePreview,
    ...PATHS.christmasCards
  ].includes(pathname.toLowerCase())

  const sessionReady =
    isNotNilOrEmpty(userToken) &&
    !isNilOrEmpty(userPermissions) &&
    authStatus === LoadingStatus.loaded

  useEffect(() => {
    if (!startRefreshToken || !sessionReady) return

    const refreshToken = setInterval(
      () => {
        dispatch(refreshAuthToken())
      },
      minutesToMilliseconds(25)
    )

    return () => {
      clearInterval(refreshToken)
    }
  }, [dispatch, sessionReady, startRefreshToken])

  return null
}
